function loadMoreResults(){
var results_on_page = jQuery('.results-on-page');
var next_url = results_on_page.data('next-url');
var delay_type = results_on_page.data('delay-type');
var delay_speed = results_on_page.data('delay-speed');
var load_more_btn = jQuery('.load-more__btn');
var load_more_spinner = jQuery('.load-more__spinner');
var current_page = results_on_page.data('current-page');
var last_item = results_on_page.find(".grid__item").last().data("product-id");

jQuery.ajax(
    {
        url: next_url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function(){
            //remove appended class from products who are now not the most recently appended
            results_on_page.find('.appended_product').each(function() {
                $(this).removeClass('appended_product');
            })
            load_more_btn.hide();
            load_more_spinner.show();
            last_item = results_on_page.find(".grid__item").last().data("product-id");
        }
    }
).done(function(next_page){
    var new_results = jQuery(next_page).find('.results-on-page');
    var new_url = new_results.data('next-url');
    var loaded = 0;
    var new_results_html = $(new_results.html());
    results_on_page.append(new_results_html);
    load_more_spinner.hide();
    if (new_url) {
        load_more_btn.show();
        next_url = new_url;
        results_on_page.data('next-url', next_url);
        current_page++;
        results_on_page.data('current-page', current_page);
    }
});
} 
